import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", location.pathname);
    api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } })
      .then(({ data }) => navigate("/admin", { replace: true, state: { user: data } }))
      .catch(() => navigate("/admin/login", { replace: true }));
  }, [location, navigate]);

  return <div className="min-h-screen bg-[#F2ECE4]" data-testid="auth-callback" />;
}
